import React, {useState, useEffect, useRef} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {GoogleMap, useJsApiLoader} from '@react-google-maps/api';
import {Circle} from '@react-google-maps/api';
import {Marker, InfoWindow} from '@react-google-maps/api';
import {LogarithmicRangeInput} from '../varios/LogarithmicRangeInput';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


export const ModalMapa = (props) => {
	const {
		ModalUbiacion,
		setModalUbiacion,
		Ubicacion,
		setUbicacion,
		RadioUbicacion,
		setRadioUbicacion,
		empresas,
		zoom,
	} = props;

    const navigate = useNavigate()

	const getUbicacion = () => {
		empresas.map((empresa) => {
			console.log(empresa);
		});
		if ('geolocation' in navigator) {
			var options = {
				enableHighAccuracy: true,
			};
			navigator.geolocation.getCurrentPosition(
				function (position) {
					var latitude = position.coords.latitude;
					var longitude = position.coords.longitude;
					setUbicacion({lat: latitude, lng: longitude});
				},
				function (error) {
					console.log('Error al obtener la ubicación: ' + error.message);
				},
				options
			);
		} else {
			console.log('error');
		}
	};

	useEffect(() => {
		getUbicacion();
	}, []);

	const {isLoaded} = useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: 'AIzaSyBt5CcFk1btCb9QpnwAmEtPNI7k4U3loEU',
	});

	const mapRef = React.createRef();

	const [activeMarker, setActiveMarker] = useState(null);

	const [markers, setMarkers] = useState([]);

	const handleActiveMarker = (marker) => {
		if (marker === activeMarker) {
			return;
		}
		setActiveMarker(marker);
	};

	const handleOnLoad = (map) => {
		const bounds = new window.google.maps.LatLngBounds(Ubicacion);
		//markers.forEach(({ position }) => bounds.extend(position));
		map.fitBounds(bounds);
	};

	function distance(lat1, lon1, lat2, lon2, unit) {
		if (lat1 == lat2 && lon1 == lon2) {
			return 0;
		} else {
			var radlat1 = (Math.PI * lat1) / 180;
			var radlat2 = (Math.PI * lat2) / 180;
			var theta = lon1 - lon2;
			var radtheta = (Math.PI * theta) / 180;
			var dist =
				Math.sin(radlat1) * Math.sin(radlat2) +
				Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = (dist * 180) / Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit == 'K') {
				dist = dist * 1.609344;
			}
			if (unit == 'N') {
				dist = dist * 0.8684;
			}
			return dist;
		}
	}

	const clearMarkers = () => {
		for (let i = 0; i < markers.length; i++) {
			markers[i].setMap(null);
		}
	};

	const updateMarkers = () => {
		clearMarkers();
		let d = 0;
		let mark = {};
		setMarkers([]);

		empresas.map((empresa) => {
			axios({
				method: 'get',
				url: window.ipdirection + 'sedePrestador_Cliente/' + empresa.id + '/',
			})
				.then((response) => {
					axios({
						method: 'get',
						url: window.ipdirection + 'imagenPerfilEmpresaCliente/' + empresa.id + '/',
						responseType: 'blob',
					})
						.then((responseImg) => {
							axios({
								method: 'get',
								url:
									window.ipdirection +
									'servicioEmpresaCliente/?empresa_id=' +
									empresa.id,
							})
								.then((responseSrv) => {
									let lista = [];
									responseSrv.data.map((servicio) => {
										lista.push({...servicio});
									});
									d = distance(
										response.data.lat,
										response.data.lng,
										Ubicacion.lat,
										Ubicacion.lng,
										'K'
									);
									if (d <= RadioUbicacion / 1000) {
										mark = {
											img: URL.createObjectURL(responseImg.data),
											id: empresa.id,
											name: empresa.nombreEmpresa,
											position: {
												lat: response.data.lat,
												lng: response.data.lng,
											},
											url: 'perfilAgencia/' + empresa.id,
											descripcion: empresa.descripcionEmpresa,
											servicios: lista,
										};
										markers.push({...mark});
										setMarkers([...markers]);
									}
								})
								.catch((error) => console.log(error));
						})
						.catch((error) => console.log(error));
				})
				.catch((error) => console.log(error));
		});
	};

	const updateUbicacion = (e) => {
		setUbicacion({lat: e.latLng.lat(), lng: e.latLng.lng()});
		updateMarkers();
	};

	const updateRadio = (e) => {
		setRadioUbicacion(parseInt(e.target.value));
		updateMarkers();
	};

	/**/

	/**/

	return isLoaded ? (
		<>
			<Modal
				centered={true}
				isOpen={ModalUbiacion}
				size='lg'
			>
				<ModalHeader>
					<div className='titulo-modal'>Ubicación</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Seleccione la ubicación y el radio para el que quiere hacer la búsqueda.
					</div>
					<div className='centrador centrador-mapas'>
						<GoogleMap
							zoom={13}
							/*onLoad={handleOnLoad}*/
							mapContainerStyle={{width: '100%', height: '100%'}}
							center={Ubicacion}
							onClick={(e) => updateUbicacion(e)}
						>
							{markers.map(
								({img, id, name, position, url, descripcion, servicios}) => (
									<Marker
										key={id}
										position={position}
										onClick={() => handleActiveMarker(id)}
									>
										{activeMarker === id ? (
											<InfoWindow
												maxWidth={100}
												onCloseClick={() => setActiveMarker(null)}
											>
												<div>
													<img
														style={{
															float: 'right',
															margin: '0 0 0 0px',
														}}
														src={img}
														width='100px'
													></img>
													<h6>{name}</h6>
													<p>{descripcion}</p>
													<br />
													<p>
														<h6>Servicios</h6>
														<ul>
															{servicios.map((s) => (
																<li key={s.id}>
																	{s.servicio_id['nombre']}
																</li>
															))}
														</ul>
													</p>
													<br />
													{/* <p style={{textAlign: 'right'}}>
														<a href={url} className='button'>Visitar</a>
													</p> */}
                                                <div className='centrador'>
                                                    <div className='button' onClick={()=>{navigate(url)}}><b>Visitar</b></div>
                                                </div>
												</div>
											</InfoWindow>
										) : null}
									</Marker>
								)
							)}
							<>
								<Circle
									center={Ubicacion}
									radius={RadioUbicacion}
									options={{
										strokeColor: '#00FF00',
										strokeOpacity: 0.8,
										strokeWeight: 2,
										fillColor: '#00FF00',
										fillOpacity: 0.35,
									}}
									onClick={(e) => updateUbicacion(e)}
								></Circle>
								<Marker
									position={Ubicacion}
									icon={
										'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_blue.png'
									}
								/>
							</>
						</GoogleMap>
						<div className='radio-de-actuacion-registro-empresas'>
							<div>
								Descubre nuestra área de cobertura para servicios a domicilio.
								¡Encuéntranos dentro de este radio para disfrutar de nuestras
								prestaciones en la comodidad de tu hogar!:
								{' ' + RadioUbicacion / 1000 + ' km'}
							</div>
							<div className='input-range-radio-de-actuacion-registro-empresas'>
								0km
								<input
									type='range'
									color='red'
									values={RadioUbicacion}
									onClick={(e) => updateRadio(e)}
									onDragEnd={(e) => updateRadio(e)}
									onChange={(e) => setRadioUbicacion(parseInt(e.target.value))}
									min={500}
									max={600000}
									step={1000}
								/>
								600km
							</div>
						</div>
						{/*
                            <input type="number" value={Steps} onChange={(e) => setSteps(e.target.value)} />
                            */}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => {
								setModalUbiacion(false);
								setActiveMarker(null);
							}}
						>
							<b>Volver</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	) : (
		<>
			{getUbicacion()}
			Cargando mapa...
		</>
	);
};
